module.exports = __webpack_public_path__ + "img/sindhotelro.36456bab.jpg";